// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"3bac0351","488":"ad11abce","777":"992eb25e"}[chunkId] + ".chunk.js";
};